import { render, staticRenderFns } from "./BarDashboard.vue?vue&type=template&id=229d6483"
import script from "./BarDashboard.vue?vue&type=script&lang=js"
export * from "./BarDashboard.vue?vue&type=script&lang=js"
import style0 from "./BarDashboard.vue?vue&type=style&index=0&id=229d6483&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports